export var StreamType;
(function(StreamType) {
    StreamType["WITH_OFFSET"] = "WITH_OFFSET";
    StreamType["WITH_CURSOR"] = "WITH_CURSOR";
})(StreamType || (StreamType = {}));
